export default __webpack_public_path__ + "static/media/milestone 7.c014e818.svg";